<div class="dashboardWidgetContainer">
    <h2>{{ 'dashboard.downloadReports.title' | translate }}</h2>

    <div class="reportContainer listContainer">
        <div class="listHeader">{{ 'dashboard.downloadReports.header' | translate }}</div>
        <ul class="list">
            @for (report of reports; track report.operationName) {
                <li class="listItem">
                    <div>
                        <i class="fas fa-file-excel"></i> &nbsp;
                        <span
                            [ngClass]="!report.isInProgress ? 'linkLike' : ''"
                            (click)="!report.isInProgress && downloadReport(report.reportType)"
                            >{{ report.translationPath | translate }}</span
                        >
                    </div>
                    @if (report.isInProgress) {
                        <div>
                            <i class="fas fa-loader" title="{{ 'notifications.statuses.tooltips.IN_PROGRESS' | translate }}"></i>
                        </div>
                    }
                </li>
            }
        </ul>
    </div>
</div>
